'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Helpers = require('common/Helpers');

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

var _Toggle = require('components/Toggle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateProductPrice = function updateProductPrice(data) {

  console.log('==== UPP', data);

  var id = data.id,
      price = data.price,
      compareAtPrice = data.compareAtPrice;

  var container = (0, _Helpers.getContainer)({ id: id });
  var $price = $(_Dom2.default.price, container);
  var $compareAtPrice = $(_Dom2.default.compareAtPrice, container);

  if (price) {
    $price.text((0, _Helpers.priceString)(price * 100));
  }

  if (compareAtPrice) {
    $compareAtPrice.text((0, _Helpers.priceString)(compareAtPrice * 100));
  }
};

var updateKlarnaAmounts = function updateKlarnaAmounts(data) {
  var id = data.id,
      price = data.price;

  var container = (0, _Helpers.getContainer)({ id: id });

  $('klarna-placement', container).attr('data-purchase_amount', price);

  window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
  window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
};

var init = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var klarnaPlacement, klarnaCountries, klarnaVisibleIn, flowCountry;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            klarnaPlacement = $(_Dom2.default.klarnaPlacement)[0];

            if (klarnaPlacement) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return');

          case 4:
            klarnaCountries = $(_Dom2.default.klarnaPlacement)[0].dataset.klarnaVisibleInCountries;
            klarnaVisibleIn = klarnaCountries ? klarnaCountries.split(',') : [];
            flowCountry = 'USA';

            // If Flow is present and there is an active experience, use that country

            if (!(window.Flow.getExperience && window.Flow.getExperience())) {
              _context.next = 11;
              break;
            }

            _context.next = 10;
            return _Flow2.default.getCountry();

          case 10:
            flowCountry = _context.sent;

          case 11:

            if (klarnaVisibleIn.includes(flowCountry) || !klarnaVisibleIn.length) {
              (0, _Toggle.toggleElement)({ selector: _Dom2.default.klarnaPlacement, action: 'add' });
            }
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](0);
            throw new Error('Error initializing Price component.');

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 14]]);
  }));

  return function init() {
    return _ref.apply(this, arguments);
  };
}();

exports.default = {
  init: init,
  updateKlarnaAmounts: updateKlarnaAmounts,
  updateProductPrice: updateProductPrice
};